import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';

import activities from './reducers/activities';
import cameraTarget from './reducers/camera';
import { clockReducer as clock } from './Clock';
import { activeSegment, segments } from './Segments';
import layout from './reducers/layout';
import scene from './reducers/scene';
import messages from './reducers/messages';
import modal from './reducers/modal';
import { playheadsReducer as playheads } from './Playhead';
import { tracksReducer as tracks } from './Track';
import { statsReducer as stats } from './Stats';
import { inputReducer as input } from './Input';
import { loadingReducer as loading } from './Loading';
import { courseReducer as course } from './Course';

function fatalError(state = null, action) {
  if (action.type === 'FATAL_ERROR') {
    return action.error || 'default';
  }
  return state;
}

export default function ViewerStore() {
  const rootReducer = combineReducers({
    activities,
    activeSegment,
    cameraTarget,
    clock,
    messages,
    modal,
    layout,
    segments,
    stats,
    scene,
    playheads,
    tracks,
    input,
    loading,
    course,
    fatalError,
  });

  // Allow tests to reset the state easily before we apply our root reducer
  function reducer(action, state) {
    if (action.type === 'RESET_STORE') state = undefined;
    return rootReducer(action, state);
  }

  Object.assign(this, createStore(reducer, {}, applyMiddleware(thunk)));
}
